(function () {
  'use strict';

  const dialog = document.querySelector('[data-detalora-zoom]');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const canvas = dialog.querySelector('[data-zoom-canvas]');
  const image = dialog.querySelector('[data-zoom-image]');
  const caption = dialog.querySelector('[data-zoom-caption]');
  const count = dialog.querySelector('[data-zoom-count]');
  const message = dialog.querySelector('[data-zoom-message]');
  const close = dialog.querySelector('[data-zoom-close]');
  const previous = dialog.querySelector('[data-zoom-previous]');
  const next = dialog.querySelector('[data-zoom-next]');
  const zoomIn = dialog.querySelector('[data-zoom-in]');
  const zoomOut = dialog.querySelector('[data-zoom-out]');
  const fit = dialog.querySelector('[data-zoom-fit]');
  const pointers = new Map();
  const enhanced = new WeakSet();
  const MAX_SCALE = 4;
  let entries = [], index = 0, scale = 1, x = 0, y = 0, width = 0, height = 0;
  let ready = false, gesture = null, sequence = null, lastTap = null;
  let opener = null, scrollState = null;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const canonical = src => { try { return new URL(src, document.baseURI).href; } catch (_) { return src; } };
  const point = event => {
    const rect = canvas.getBoundingClientRect();
    return { x: event.clientX - rect.left - rect.width / 2, y: event.clientY - rect.top - rect.height / 2 };
  };
  const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const midpoint = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

  function paint() {
    const limitX = Math.max(0, (width * scale - canvas.clientWidth) / 2);
    const limitY = Math.max(0, (height * scale - canvas.clientHeight) / 2);
    x = clamp(x, -limitX, limitX);
    y = clamp(y, -limitY, limitY);
    image.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) scale(${scale})`;
    canvas.classList.toggle('is-zoomed', scale > 1.01);
    fit.textContent = `${Math.round(scale * 100)}%`;
    zoomOut.disabled = !ready || scale <= 1.001;
    zoomIn.disabled = !ready || scale >= MAX_SCALE - 0.001;
    fit.disabled = !ready;
  }

  function reset() {
    scale = 1; x = 0; y = 0;
    pointers.clear(); gesture = null; sequence = null; lastTap = null;
    canvas.classList.remove('is-dragging');
    paint();
  }

  function measure() {
    if (!dialog.open || !ready || !image.naturalWidth || !image.naturalHeight) return;
    const ratio = Math.min(1, Math.max(1, canvas.clientWidth - 24) / image.naturalWidth,
      Math.max(1, canvas.clientHeight - 24) / image.naturalHeight);
    width = image.naturalWidth * ratio;
    height = image.naturalHeight * ratio;
    image.style.width = `${width}px`;
    image.style.height = `${height}px`;
    reset();
  }

  function loaded() {
    if (!dialog.open || !image.complete || !image.naturalWidth) return;
    ready = true; message.hidden = true; image.hidden = false;
    measure();
  }

  function show(nextIndex) {
    index = (nextIndex + entries.length) % entries.length;
    ready = false; image.hidden = true; message.hidden = false;
    message.textContent = dialog.dataset.loadingLabel;
    reset();
    const entry = entries[index];
    image.alt = entry.alt;
    caption.textContent = entry.alt;
    count.textContent = `${index + 1} / ${entries.length}`;
    previous.disabled = next.disabled = entries.length < 2;
    image.src = entry.src;
    if (image.complete && image.naturalWidth) loaded();
  }

  function zoomTo(value, anchor = { x: 0, y: 0 }) {
    if (!ready) return;
    const newScale = clamp(value, 1, MAX_SCALE);
    x = anchor.x - (anchor.x - x) * newScale / scale;
    y = anchor.y - (anchor.y - y) * newScale / scale;
    scale = newScale;
    paint();
  }

  function lockScroll() {
    const body = document.body;
    const properties = ['position', 'top', 'left', 'width', 'overflow'];
    scrollState = { x: window.scrollX, y: window.scrollY,
      styles: properties.map(key => [key, body.style.getPropertyValue(key), body.style.getPropertyPriority(key)]) };
    body.style.position = 'fixed'; body.style.top = `-${scrollState.y}px`;
    body.style.left = `-${scrollState.x}px`; body.style.width = '100%'; body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (!scrollState) return;
    scrollState.styles.forEach(([key, value, priority]) => {
      if (value) document.body.style.setProperty(key, value, priority);
      else document.body.style.removeProperty(key);
    });
    const html = document.documentElement;
    const behavior = html.style.getPropertyValue('scroll-behavior');
    const priority = html.style.getPropertyPriority('scroll-behavior');
    html.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(scrollState.x, scrollState.y);
    if (behavior) html.style.setProperty('scroll-behavior', behavior, priority);
    else html.style.removeProperty('scroll-behavior');
    scrollState = null;
  }

  function openFor(source, trigger) {
    if (dialog.open) return;
    const gallery = source.closest('[data-product-gallery]');
    entries = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-thumb]'))
      .filter(thumb => !thumb.hidden && thumb.dataset.src)
      .map(thumb => ({ src: thumb.dataset.src, alt: thumb.dataset.alt || source.alt || '' })) : [];
    // The standard product image's src is the full 1200px file; currentSrc may
    // be a 480px responsive candidate chosen for the small inline preview.
    const selectedSrc = gallery ? (source.currentSrc || source.src) : (source.src || source.currentSrc);
    let selectedIndex = entries.findIndex(entry => canonical(entry.src) === canonical(selectedSrc));
    if (!entries.length || selectedIndex < 0) {
      entries = [{ src: selectedSrc, alt: source.alt || '' }]; selectedIndex = 0;
    }
    opener = trigger;
    lockScroll();
    try { dialog.showModal(); } catch (_) { unlockScroll(); return; }
    show(selectedIndex);
    close.focus({ preventScroll: true });
  }

  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    reset(); unlockScroll();
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      const buttons = Array.from(dialog.querySelectorAll('button:not(:disabled)'));
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
      return;
    }
    // Keep the existing cart's document-level Escape handler out of this dialog.
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
    else if (event.key === 'ArrowLeft' && entries.length > 1) { event.preventDefault(); show(index - 1); }
    else if (event.key === 'ArrowRight' && entries.length > 1) { event.preventDefault(); show(index + 1); }
    else if (event.key === '+' || event.key === '=') { event.preventDefault(); zoomTo(scale * 1.5); }
    else if (event.key === '-') { event.preventDefault(); zoomTo(scale / 1.5); }
    else if (event.key === '0') { event.preventDefault(); reset(); }
  });
  previous.addEventListener('click', () => show(index - 1));
  next.addEventListener('click', () => show(index + 1));
  zoomIn.addEventListener('click', () => zoomTo(scale * 1.5));
  zoomOut.addEventListener('click', () => zoomTo(scale / 1.5));
  fit.addEventListener('click', reset);
  image.addEventListener('load', loaded);
  image.addEventListener('error', () => {
    if (!dialog.open) return;
    ready = false; image.hidden = true; message.hidden = false;
    message.textContent = dialog.dataset.errorLabel; paint();
  });

  function startGesture() {
    const values = Array.from(pointers.values());
    if (values.length >= 2) {
      const center = midpoint(values[0], values[1]);
      gesture = { type: 'pinch', distance: Math.max(1, distance(values[0], values[1])), scale,
        contentX: (center.x - x) / scale, contentY: (center.y - y) / scale };
      if (sequence) sequence.multi = true;
    } else if (values.length === 1) {
      gesture = { type: 'pan', start: values[0], x, y };
    } else gesture = null;
  }

  canvas.addEventListener('pointerdown', event => {
    if (!ready || (event.pointerType === 'mouse' && event.button !== 0)) return;
    const position = point(event);
    if (!pointers.size) sequence = { start: position, moved: false, multi: false, time: Date.now(), scale };
    pointers.set(event.pointerId, position);
    canvas.setPointerCapture(event.pointerId);
    canvas.classList.toggle('is-dragging', scale > 1.01);
    startGesture();
  });
  canvas.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    const position = point(event);
    pointers.set(event.pointerId, position);
    if (sequence && distance(sequence.start, position) > 8) sequence.moved = true;
    const values = Array.from(pointers.values());
    if (gesture.type === 'pinch' && values.length >= 2) {
      const center = midpoint(values[0], values[1]);
      scale = clamp(gesture.scale * distance(values[0], values[1]) / gesture.distance, 1, MAX_SCALE);
      x = center.x - gesture.contentX * scale; y = center.y - gesture.contentY * scale;
    } else if (gesture.type === 'pan' && scale > 1) {
      x = gesture.x + position.x - gesture.start.x;
      y = gesture.y + position.y - gesture.start.y;
    }
    paint();
  });
  function finishPointer(event, cancelled) {
    if (!pointers.has(event.pointerId)) return;
    const end = point(event);
    pointers.delete(event.pointerId);
    if (pointers.size) { startGesture(); return; }
    canvas.classList.remove('is-dragging'); gesture = null;
    const done = sequence; sequence = null;
    if (cancelled || !done || done.multi) { lastTap = null; return; }
    const dx = end.x - done.start.x, dy = end.y - done.start.y;
    if (done.scale <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4 && entries.length > 1) {
      show(index + (dx < 0 ? 1 : -1)); return;
    }
    if (!done.moved && distance(done.start, end) <= 8 && Date.now() - done.time < 350) {
      if (lastTap && Date.now() - lastTap.time < 320 && distance(lastTap, end) < 28) {
        zoomTo(scale > 1.01 ? 1 : 2, end); lastTap = null;
      } else lastTap = { ...end, time: Date.now() };
    } else lastTap = null;
  }
  canvas.addEventListener('pointerup', event => finishPointer(event, false));
  canvas.addEventListener('pointercancel', event => finishPointer(event, true));
  canvas.addEventListener('lostpointercapture', event => finishPointer(event, true));
  canvas.addEventListener('wheel', event => {
    if (!ready) return;
    event.preventDefault();
    const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? canvas.clientHeight : 1);
    zoomTo(scale * Math.exp(-clamp(delta, -150, 150) * .006), point(event));
  }, { passive: false });
  canvas.addEventListener('dragstart', event => event.preventDefault());
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(canvas);
  else window.addEventListener('resize', measure);

  function enhance(scope) {
    scope.querySelectorAll('[data-gallery-main], .solution-model figure > img, .shopify-product-media > img').forEach(source => {
      if (enhanced.has(source) || source.closest('a, button')) return;
      enhanced.add(source);
      source.classList.add('detalora-zoom-trigger');
      source.setAttribute('role', 'button'); source.tabIndex = 0;
      source.setAttribute('aria-haspopup', 'dialog'); source.setAttribute('aria-controls', dialog.id);
      function label() { source.setAttribute('aria-label', `${dialog.dataset.openLabel}: ${source.alt || ''}`); }
      label(); new MutationObserver(label).observe(source, { attributes: true, attributeFilter: ['alt'] });
      let start = null, suppressUntil = 0;
      source.addEventListener('pointerdown', event => {
        if (!event.isPrimary) suppressUntil = Date.now() + 700;
        start = { x: event.clientX, y: event.clientY };
      }, { passive: true });
      source.addEventListener('pointermove', event => {
        if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 8) suppressUntil = Date.now() + 700;
      }, { passive: true });
      source.addEventListener('pointerup', () => { start = null; }, { passive: true });
      source.addEventListener('pointercancel', () => { start = null; suppressUntil = Date.now() + 700; }, { passive: true });
      source.addEventListener('click', event => {
        if (Date.now() < suppressUntil) { event.preventDefault(); return; }
        openFor(source, source);
      });
      source.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openFor(source, source); }
      });
      const stage = source.closest('[data-gallery-stage]');
      if (stage && !stage.querySelector('.detalora-zoom-hint')) {
        const hint = document.createElement('button');
        hint.type = 'button'; hint.className = 'detalora-zoom-hint';
        hint.setAttribute('aria-label', dialog.dataset.openLabel); hint.title = dialog.dataset.openLabel;
        hint.setAttribute('aria-haspopup', 'dialog'); hint.setAttribute('aria-controls', dialog.id);
        hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6M10 7v6"/></svg>';
        hint.addEventListener('click', () => openFor(source, hint));
        stage.appendChild(hint);
      }
    });
  }
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
